import React, { useState } from "react";
import "../../style/main.scss";
import { Icon } from "@iconify/react";
import Accordion from "react-bootstrap/Accordion";
import Agent from "./create/agent";
import Knowledge from "./create/knowledge";
import CreateScript from "./create/CreateScript";

const Tabs = () => {
  const [activeFilter, setActiveFilter] = useState("Agent");
  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
  };

  return (
    <div>
      <div className="two-sections">
        <div className="left-main">
          <div className="left">
            <div className="content">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <div className="d-flex align-items-center gap-2">
                      <Icon
                        icon="teenyicons:home-outline"
                        color="white"
                        width="24"
                        height="24"
                      />
                      <p>Create</p>
                    </div>
                    <span>
                      <Icon
                        icon="majesticons:chevron-up-line"
                        color="white"
                        width="24"
                        height="24"
                        rotate={90}
                      />
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div
                      className={`${activeFilter === "Agent" ? "active" : ""}`}
                      onClick={() => handleFilterClick("Agent")}
                    >
                      <Icon
                        icon="mdi:dot"
                        color="white"
                        width="24"
                        height="24"
                      />
                      Agents
                    </div>
                  </Accordion.Body>
                  <Accordion.Body>
                    <div
                      className={`${
                        activeFilter === "Knowledge" ? "active" : ""
                      }`}
                      onClick={() => handleFilterClick("Knowledge")}
                    >
                      <Icon
                        icon="mdi:dot"
                        color="white"
                        width="24"
                        height="24"
                      />
                      Knowledge Bases
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            {/* <div className="content">
              <Accordion>
                <Accordion.Item eventKey="0">
                  <Accordion.Header
                    onClick={() => handleFilterClick("CreateScript")}
                  >
                    <div className="d-flex align-items-center gap-2">
                  
                      <p>Create Script</p>
                    </div>
                  </Accordion.Header>
                </Accordion.Item>
              </Accordion>
            </div> */}
          </div>
        </div>
        <div className="right">
          {activeFilter === "Agent" && <Agent />}
          {activeFilter === "Knowledge" && <Knowledge />}
          {/* {activeFilter === "CreateScript" && <CreateScript/>} */}
        </div>
      </div>
    </div>
  );
};

export default Tabs;
